import app from '../../main'
const qs = require('qs')

export default {
    namespaced: true,
    state: {
        products: [],
        mobileProducts: [],
        product: {},
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 16
        },
        sort: 'New:dsc',
        errors: {
            getProducts: '',
            getProduct: '',
            createProduct: '',
            updateProduct: '',
            updateProductsMass: '',
            deleteProductsMass: ''
        }
    },
    getters: {
        getFormattedProduct(state, getters, rootState, rootGetters) {
            if (!Object.keys(state.product).length) return {}
            let product = {
                id: state.product.ItemID,
                category: state.product.CategoryID,
                type: state.product.TypeID,
                material: state.product.materials[0].MaterialID,
                collection: state.product.CollectionID,
                fineness: rootGetters['finenesses/getFinenessIdByName'](
                    state.product.materials[0].pivot.Fineness,
                    state.product.materials[0].MaterialID
                ),
                color: state.product.materials[0].pivot.ColorID,
                technology: state.product.TechnologyID,
                decor: state.product.decor.length
                    ? state.product.decor[0].DecorID
                    : '',
                purpose: state.product.purposes.length
                    ? state.product.purposes[0].PurposeID
                    : '',
                priceUnit: state.product.PriceUnit,
                brand: state.product.brand.BrandID,
                article: state.product.Article,
                name: state.product.Name,
                size: state.product.Size,
                price: state.product.Price,
                weight: state.product.Weight,
                descr: state.product.Description,
                supplierurl: state.product.SupplierURL,
                iteminsert: state.product.ItemInsert,
                inserts: state.product.inserts.map(item => {
                    return {
                        id: item.ItemInsertID,
                        material: item.MaterialID,
                        color: item.ColorID,
                        facet: item.FacetID,
                        clarity: item.Clarity,
                        size: item.Size,
                        quantity: item.Quantity,
                        faceNumber: item.FaceNumber
                    }
                }),
                images: state.product.images,
                visibility: state.product.access
                    ? state.product.access.AccessLevel
                    : 0
            }
            return product
        },
        getProductKeyValue: state => (productId, keyName) => {
            if (!productId || !keyName) return ''
            return state.products.find(item => item.ItemID == productId)[
                keyName
            ]
        }
    },
    mutations: {
        SET_PRODUCTS(state, payload) {
            state.products = payload
        },
        CLEAR_PRODUCTS(state) {
            state.products = []
            state.mobileProducts = []
            state.product = {}
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 16
            }
        },
        SET_MOBILE_PRODUCTS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileProducts = payload
            } else {
                state.mobileProducts = [...state.mobileProducts, ...payload]
            }
        },
        SET_PRODUCT(state, payload) {
            state.product = payload
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_SORT(state, sort) {
            state.sort = sort
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        setPagination({ commit }, pagination) {
            for (const [key, value] of Object.entries(pagination)) {
                commit('SET_PAGINATION', {
                    key,
                    val: value
                })
            }
        },
        clearProducts({ commit, state }) {
            commit('CLEAR_PRODUCTS')
        },
        async getProducts({ commit, state, dispatch }, data) {
            commit('SET_ERRORS', {
                key: 'getProducts',
                val: ''
            })

            const url = '/public/items'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                app.$Progress.finish()

                commit('SET_PRODUCTS', resp.data)

                dispatch('setPagination', {
                    page: parseInt(resp.headers['page']),
                    totalPages: parseInt(resp.headers['total-pages']),
                    totalProducts: parseInt(resp.headers['total-records']),
                    pageSize: parseInt(resp.headers['page-size'])
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_PRODUCTS', resp.data)
                }
            } catch (e) {
                commit('SET_ERRORS', {
                    key: 'getProducts',
                    val: 'Ошибка'
                })
                app.$Progress.fail()
                if (e.response) {
                    console.log(e.response.data)
                } else {
                    console.log('Ошибка ' + e.message)
                }
            }
        },
        async getProduct({ commit }, productId) {
            commit('SET_ERRORS', {
                key: 'getProduct',
                val: ''
            })

            const url = `/public/items/${productId}`

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_PRODUCT', resp)
                return resp
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getProduct',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getProduct',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async createProduct({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'createProduct',
                val: ''
            })

            const url = '/public/items'

            try {
                const resp = await this.$axios.post(url, data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'createProduct',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async updateProduct({ commit }, payload) {
            commit('SET_ERRORS', {
                key: 'updateProduct',
                val: ''
            })

            const url = '/public/items/' + payload.id + '/' + payload.type

            try {
                const resp = await this.$axios.patch(url, payload.data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updateProduct',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async setSort({ commit }, value) {
            commit('SET_SORT', value)
        }
    }
}
